@if (accessService.loaded()) {
  <div class="flex items-center gap-2 min-w-0 flex-wrap">
    <span
      class="material-symbols-outlined text-text-tertiary text-[18px] md:text-[20px] shrink-0"
      aria-hidden="true"
    >business</span>
    <app-select
      variant="inline"
      [options]="businessOptions()"
      [ngModel]="accessService.selectedBusinessId() ?? ''"
      (ngModelChange)="onBusinessChange($event)"
      placeholder="Select Business"
      ariaLabel="Select business"
    />

    @if (accessService.selectedBusinessId()) {
      <div class="h-5 w-px bg-border-medium shrink-0"></div>
      <span
        class="material-symbols-outlined text-text-tertiary text-[18px] md:text-[20px] shrink-0"
        aria-hidden="true"
      >store</span>
      <app-select
        variant="inline"
        [options]="branchOptions()"
        [ngModel]="accessService.selectedBranchId() ?? ''"
        (ngModelChange)="onBranchChange($event)"
        placeholder="All Branches"
        ariaLabel="Select branch"
      />
    }
  </div>
}
